module.exports = __webpack_public_path__ + "img/pause_icon.3351e47e.svg";